import * as types from '../constants/itSalesConstants';

// Get IT Sales Partners
export const getItSalesPartnersRequest = () => ({
  type: types.GET_ITSALES_PARTNERS_REQUEST,
});

export const getItSalesPartnersSuccess = (data) => ({
  type: types.GET_ITSALES_PARTNERS_SUCCESS,
  payload: data,
});

export const getItSalesPartnersFailure = (error) => ({
  type: types.GET_ITSALES_PARTNERS_FAILURE,
  payload: error,
});

export const getItSalesPartners = (params) => ({
  type: types.GET_ITSALES_PARTNERS_REQUEST,
  payload: params,
});

// Add IT Sales Partner
export const addItSalesPartnerRequest = () => ({
  type: types.ADD_ITSALES_PARTNER_REQUEST,
});

export const addItSalesPartnerSuccess = (data) => ({
  type: types.ADD_ITSALES_PARTNER_SUCCESS,
  payload: data,
});

export const addItSalesPartnerFailure = (error) => ({
  type: types.ADD_ITSALES_PARTNER_FAILURE,
  payload: error,
});

export const addItSalesPartner = (partnerData) => ({
  type: types.ADD_ITSALES_PARTNER_REQUEST,
  payload: partnerData,
});

// Edit IT Sales Partner
export const editItSalesPartnerRequest = () => ({
  type: types.EDIT_ITSALES_PARTNER_REQUEST,
});

export const editItSalesPartnerSuccess = (data) => ({
  type: types.EDIT_ITSALES_PARTNER_SUCCESS,
  payload: data,
});

export const editItSalesPartnerFailure = (error) => ({
  type: types.EDIT_ITSALES_PARTNER_FAILURE,
  payload: error,
});

export const editItSalesPartner = (partnerData) => ({
  type: types.EDIT_ITSALES_PARTNER_REQUEST,
  payload: partnerData,
});

// Delete IT Sales Partner
export const deleteItSalesPartnerRequest = () => ({
  type: types.DELETE_ITSALES_PARTNER_REQUEST,
});

export const deleteItSalesPartnerSuccess = (data) => ({
  type: types.DELETE_ITSALES_PARTNER_SUCCESS,
  payload: data,
});

export const deleteItSalesPartnerFailure = (error) => ({
  type: types.DELETE_ITSALES_PARTNER_FAILURE,
  payload: error,
});

export const deleteItSalesPartner = (params) => ({
  type: types.DELETE_ITSALES_PARTNER_REQUEST,
  payload: params,
});

// Change IT Sales Status
export const changeItSalesStatusRequest = () => ({
  type: types.CHANGE_ITSALES_STATUS_REQUEST,
});

export const changeItSalesStatusSuccess = (data) => ({
  type: types.CHANGE_ITSALES_STATUS_SUCCESS,
  payload: data,
});

export const changeItSalesStatusFailure = (error) => ({
  type: types.CHANGE_ITSALES_STATUS_FAILURE,
  payload: error,
});

export const changeItSalesStatus = (params) => ({
  type: types.CHANGE_ITSALES_STATUS_REQUEST,
  payload: params,
});

// Reset IT Sales Password
export const resetItSalesPasswordRequest = () => ({
  type: types.RESET_ITSALES_PASSWORD_REQUEST,
});

export const resetItSalesPasswordSuccess = (data) => ({
  type: types.RESET_ITSALES_PASSWORD_SUCCESS,
  payload: data,
});

export const resetItSalesPasswordFailure = (error) => ({
  type: types.RESET_ITSALES_PASSWORD_FAILURE,
  payload: error,
});

export const resetItSalesPassword = (params) => ({
  type: types.RESET_ITSALES_PASSWORD_REQUEST,
  payload: params,
});

// Get Licenses
export const getLicensesRequest = () => ({
  type: types.GET_ITSALES_LICENSES_REQUEST,
});

export const getLicensesSuccess = (data) => ({
  type: types.GET_ITSALES_LICENSES_SUCCESS,
  payload: data,
});

export const getLicensesFailure = (error) => ({
  type: types.GET_ITSALES_LICENSES_FAILURE,
  payload: error,
});

export const getLicenseslist = () => ({
  type: types.GET_ITSALES_LICENSES_REQUEST,
});

// Get IT Sales Partner OEM List
export const getItSalesPartnerOemListRequest = () => ({
  type: types.GET_ITSALES_PARTNER_OEM_LIST_REQUEST,
});

export const getItSalesPartnerOemListSuccess = (data) => ({
  type: types.GET_ITSALES_PARTNER_OEM_LIST_SUCCESS,
  payload: data,
});

export const getItSalesPartnerOemListFailure = (error) => ({
  type: types.GET_ITSALES_PARTNER_OEM_LIST_FAILURE,
  payload: error,
});

export const getItSalesPartnerOemList = (params) => ({
  type: types.GET_ITSALES_PARTNER_OEM_LIST_REQUEST,
  payload: params,
});

// Get IT Sales Partner OEM Users
export const getItSalesPartnerOemUsersRequest = () => ({
  type: types.GET_ITSALES_PARTNER_OEM_USERS_REQUEST,
});

export const getItSalesPartnerOemUsersSuccess = (data) => ({
  type: types.GET_ITSALES_PARTNER_OEM_USERS_SUCCESS,
  payload: data,
});

export const getItSalesPartnerOemUsersFailure = (error) => ({
  type: types.GET_ITSALES_PARTNER_OEM_USERS_FAILURE,
  payload: error,
});

export const getItSalesPartnerOemUsers = (params) => ({
  type: types.GET_ITSALES_PARTNER_OEM_USERS_REQUEST,
  payload: params,
});

export const resendItSalesVerificationEmail = (itSalesId) => ({
  type: types.RESEND_ITSALES_VERIFICATION_EMAIL_REQUEST,
  payload: itSalesId,
});

export const resendItSalesVerificationEmailSuccess = (data) => ({
  type: types.RESEND_ITSALES_VERIFICATION_EMAIL_SUCCESS,
  payload: data,
});

export const resendItSalesVerificationEmailFailure = (error) => ({
  type: types.RESEND_ITSALES_VERIFICATION_EMAIL_FAILURE,
  payload: error,
});